export enum SimpleFormItem {
    CANCELLATION_REASON="CANCELLATION_REASON",
    CPE_MODELS="CPE_MODEL"
}
export enum ComboFormItem {
}